export class ClassificaVO {
  codice: string;
  nome: string;
  abilitaInvioComunicazioniDipendenti: boolean;
  output: string;
  id: string;
}
